const ACTIONS = {
  EDIT: "edit",
  DELETE: "delete",
  CREATE: "create",
  VIEW: "view"
}
export default ACTIONS;